import {
  REQUEST_FARM_DETAILS,
  RECEIVE_FARM_DETAILS,
  FAILURE_FARM_DETAILS,
} from '../constants/actionTypes';

export function reqFarmDetails(farmUuid) {
  return {
    type: REQUEST_FARM_DETAILS,
    farmUuid,
  };
}

export function receiveFarmDetails(details) {
  return {
    type: RECEIVE_FARM_DETAILS,
    details,
  };
}

export function farmDetailsFailure() {
  return {
    type: FAILURE_FARM_DETAILS,
  };
}
